app.directive('languageSelect', [
    '$ionicModal',
    'LocaleService',
    'LocalStorage',
    function ($ionicModal,
              LocaleService,
              LocalStorage) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                languages: '=',
                onResult: '&callback'
            },
            link: function (scope, element, attrs) {

                scope.selectedId = LocalStorage.get('language');
                scope.selectedItem = scope.languages.find(function (item) {
                    return scope.selectedId === item.id
                });

                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;

                    scope.selectedId = LocalStorage.get('language');
                    scope.selectedItem = scope.languages.find(function (item) {
                        return scope.selectedId === item.id
                    });
                });


                // region modal window
                scope.languagesModal = function () {
                    $ionicModal.fromTemplateUrl('templates/directives/languagesSelect.html', {
                        scope: scope,
                        hardwareBackButtonClose: false,
                        animation: 'slide-in-up'
                    }).then(function (modal) {
                        scope.modal = modal;
                        LocaleService.wait().then(function (translation) {
                            scope.translation = translation;
                        });

                        scope.selectedId = LocalStorage.get('language');
                        scope.languagesList = scope.languages;
                        scope.languageModal = modal;
                        scope.languageModal.show();
                    });
                };

                scope.setLanguage = function (language) {
                    scope.selectedItem = scope.languages.find(function (item) {
                        return item.id === language.id
                    });
                    scope.onResult({item: scope.selectedItem});
                    scope.languageModal && scope.languageModal.hide();
                };

                scope.closeLanguageModal = function () {
                    scope.languageModal && scope.languageModal.hide();
                    scope.languagesList = null;
                };
                // endregion
                element.on('$destroy', function () {
                    scope.modal && scope.modal.remove();
                })
            },

            template: [
                '<div class="languageSelect">',
                '<div class="result row" on-tap="languagesModal()">',
                '<i class="icon flag-union" ng-class="[{true:\'flag-icon-\'+selectedItem[\'id\']}[true]]"></i>',
                '</div>',
                '</div>'
            ].join('\n')
        }
    }]);
